<template>
  <div class="home " ref="home" id="home">
    <section class="part1 " ref="section1" id="section1">
      <div class="info" :class="scrollHeight > 200 ? 'animate__animated animate__fadeOut ' : 'animate__animated animate__fadeIn'">
        <Img src="/home/home-gy.png"></Img>
        <p>全类型、一站式区块链进阶实战</p>
      </div>
      <span
        class="home-btn"
        :class="scrollHeight > 400 ? 'animate__animated animate__fadeOut' : 'animate__animated animate__fadeIn'"
        @click="$store.commit('SET_ACTIVATEVISIBLE', { filed: 'visible4', status: true })"
        >申请试用</span
      >
    </section>
    <section class="part2 " ref="section2" id="section2">
      <dl>
        <dt :class="scrollHeight > 20 ? ' animate__animated animate__fadeInLeftBig' : ''">为什么需要真实环境？</dt>
        <dd :class="scrollHeight > 20 ? 'delay0-5  animate__animated animate__fadeInLeftBig' : ''">
          从技术角度来说，区块链是一个新兴的技术，涵盖加密算法、共识算法、分布式网络等多种技术，从设计理念来说，区块链是一种颠覆式的概念。区块链没有一个可视化的形象，给学习区块链增加了诸多困难。传统的理论知识学习仅学习区块链的基本概念，一般的模拟实训，有助于对区块链的理解以及浅层次技术的学习，但难以深入，因此通过“看得见、摸得着”的真实的环境进行区块链理论和技术的学习尤为重要。
        </dd>
      </dl>
      <div class="part2-right">
        <Img src="/home/home-1.png" alt="" :class="scrollHeight > 20 ? 'delay1 taps1 animate__animated animate__fadeInRightBig' : 'taps1'" />
        <Img src="/home/home-1-1.png" :class="scrollHeight > 20 ? 'delay1-2 animate__animated animate__fadeInRightBig' : ''" />
        <Img src="/home/home-1-2.png" :class="scrollHeight > 20 ? 'delay1-4 animate__animated animate__fadeInRightBig' : ''" />
        <Img src="/home/home-1-3.png" :class="scrollHeight > 20 ? 'delay1-6 animate__animated animate__fadeInRightBig' : ''" />
      </div>
    </section>
    <section class="slides " ref="section3" id="section3">
      <ul class="menu" :class="scrollHeight > 740 ? ' animate__animated animate__fadeInLeftBig' : ''">
        <li :class="{ active: tabIndex === index }" v-for="(item, index) in menu" :key="index" @mouseover="tabIndex = index">
          <dl>
            <dt>
              {{ item.title }}
            </dt>
            <dd>{{ item.des }}</dd>
          </dl>
        </li>
      </ul>
      <div class="slides-content">
        <div v-if="tabIndex != 1 && tabIndex != 3 && scrollHeight > 740" class="animate__animated animate__fadeInLeftBig  slides-des">
          {{ slidesDes[tabIndex] }}
        </div>
        <div class="slides-top ">
          <div class="slides-part1" v-show="tabIndex === 0 && scrollHeight > 740">
            <Img src="/home/slides1/bg.png" class="animate__animated animate__bounceInRight delay0-5" alt="" />
            <Img src="/home/slides1/icon1.png" class="animate__animated animate__bounceInRight delay0-6" alt="" />
            <Img src="/home/slides1/icon2.png" class="animate__animated animate__bounceInRight delay0-7" alt="" />
            <Img src="/home/slides1/icon3.png" class="animate__animated animate__bounceInRight delay0-8" alt="" />
            <Img src="/home/slides1/icon4.png" class="animate__animated animate__bounceInRight delay0-8" alt="" />
            <Img src="/home/slides1/icon5.png" class="animate__animated animate__bounceInRight delay1" alt="" />
            <Img src="/home/slides1/icon6.png" class="animate__animated animate__bounceInRight delay1-1" alt="" />
            <Img src="/home/slides1/icon7.png" class="animate__animated animate__bounceInRight delay1-2" alt="" />
            <Img src="/home/slides1/icon8.png" class="animate__animated animate__bounceInRight delay1-3" alt="" />
            <Img src="/home/slides1/icon9.png" class="animate__animated animate__bounceInRight delay1-4" alt="" />
            <Img src="/home/slides1/icon10.png" class="animate__animated animate__bounceInRight delay1-5" alt="" />
            <Img src="/home/slides1/icon11.png" class="animate__animated animate__bounceInRight delay1-6" alt="" />
            <Img src="/home/slides1/icon12.png" class="animate__animated animate__bounceInRight delay1-7" alt="" />
          </div>
          <div class="slides-part2" v-show="tabIndex === 1">
            <Img src="/home/slides2/bg.png" class="animate__animated animate__bounceInLeft" alt="" />
            <Img src="/home/slides2/person.png" class="animate__animated animate__bounceInLeft delay0-5" alt="" />
            <Img src="/home/slides2/gth.png" class="animate__animated animate__bounceInLeft delay0-5" alt="" />
            <Img src="/home/slides2/box.png" class="animate__animated animate__bounceInLeft delay0-4" alt="" />
            <Img src="/home/slides2/card1.png" class="animate__animated animate__bounceInLeft delay0-3" alt="" />
            <Img src="/home/slides2/card2.png" class="animate__animated animate__bounceInLeft delay0-2" alt="" />
            <Img src="/home/slides2/card3.png" class="animate__animated animate__bounceInLeft delay0-1" alt="" />
          </div>
          <div class="slides-part3 " v-show="tabIndex === 2">
            <Img src="/home/slides3/bg.png" class="animate__animated animate__bounceInRight delay0-5" alt="" />
            <Img src="/home/slides3/icon1.png" alt="" />
            <Img src="/home/slides3/icon2.png" alt="" />
            <Img src="/home/slides3/icon3.png" alt="" />
            <Img src="/home/slides3/icon4.png" alt="" />
            <Img src="/home/slides3/icon5.png" alt="" />
            <Img src="/home/slides3/icon6.png" alt="" />
            <Img src="/home/slides3/icon7.png" alt="" />
            <Img src="/home/slides3/icon8.png" alt="" />
            <Img src="/home/slides3/icon9.png" alt="" />
            <Img src="/home/slides3/icon10.png" alt="" />
          </div>
          <div class="slides-part4 animate__animated animate__bounceInRight" v-show="tabIndex === 3">
            <Img src="/home/slides4/icon1.png" class="animate__animated animate__bounceInLeft delay0-5" alt="" />
            <Img src="/home/slides4/icon2.png" class="animate__animated animate__bounceInLeft delay0-4" alt="" />
            <Img src="/home/slides4/icon3.png" class="animate__animated animate__bounceInLeft delay0-3" alt="" />
            <Img src="/home/slides4/icon4.png" class="animate__animated animate__bounceInLeft delay0-2" alt="" />
            <Img src="/home/slides4/icon5.png" class="animate__animated animate__bounceInLeft delay0-1" alt="" />
            <Img src="/home/slides4/icon6.png" class="animate__animated animate__bounceInLeft " alt="" />
          </div>
          <div class="slides-part5 animate__animated animate__fadeInRight delay0-6" v-show="tabIndex === 4">
            <Img src="/home/slides5.png" alt="" />
            <p class="codeText" style="white-space:pre;" v-html="codeText"></p>
          </div>
        </div>
        <div v-if="tabIndex === 1 || tabIndex === 3" class="animate__animated animate__bounceInRight delay0-7 slides-des">
          {{ slidesDes[tabIndex] }}
        </div>
      </div>
    </section>
    <section class="part8 " ref="section4" id="section4">
      <h2 :class="scrollHeight > 1300 ? 'animate__animated animate__pulse ' : ''">合作伙伴</h2>
      <div class="partner">
        <div class="partner-left ">
          <p v-for="item in 12" :key="item" :class="scrollHeight > 1500 ? 'animate__animated animate__fadeInLeft delay0-5' : ''">
            <Img :src="`/home/p${item}.png`" />
          </p>
        </div>
        <div class="partner-right">
          <p v-for="item in [13, 14]" :key="item" :class="scrollHeight > 1500 ? 'animate__animated animate__fadeInLeft delay0-5' : ''">
            <Img :src="`/home/p${item}.png`" />
          </p>
        </div>
      </div>
      <a
        href="javascript:;"
        :class="scrollHeight > 1600 ? 'btn animate__animated animate__fadeInUp delay1-4' : ''"
        @click="$store.commit('SET_ACTIVATEVISIBLE', { filed: 'visible4', status: true })"
      >
        成为智谷星图合作伙伴
      </a>
    </section>
    <div class="part-footer " ref="section5" id="section5">
      <div class="footer">
        <ul>
          <li>
            <a href="https://www.zhiguxingtu.com/product.html" target="_blank">实训产品</a>
          </li>
          <li>
            <a href="https://www.zhiguxingtu.com/service.html" target="_blank">教育服务</a>
          </li>
          <li>
            <a href="https://www.zhiguxingtu.com/about.html" target="_blank">关于智谷星图</a>
          </li>
        </ul>
        <ul>
          <li>
            联系我们
          </li>
          <li>
            微信号：svs007admin
          </li>
          <li>
            邮箱：contact@svinsight.com
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrollHeight: 0,
      scrollTop: 0,
      oldScrollTop: 0,
      partNum: 0,
      sysInfo: {},
      typingObj: {
        i: 0,
        timer: null,
        str: `pragma solidity ^0.4.18;
contract HelloWorld {
    string msg = 'Hello World';

    function helloworld(string _msg) public {
        msg = _msg;
    }

    function say() constant public returns (string) {
        return msg;
    }
}`
      },
      codeText: '',
      menu: [
        {
          title: '真实区块链环境',
          des: '将区块链真实环境引入区块链学习'
        },
        {
          title: '丰富的底层环境库',
          des: '包含8+种真实区块链环境'
        },
        {
          title: '完备的工具库',
          des: '配套完备的区块链工具'
        },
        {
          title: '多级别多领域实战任务',
          des: '搭载适用多专业、多级别的实战任务'
        },
        {
          title: '丰富的案例代码',
          des: '内置多类型、多行业的案例代码'
        }
      ],
      tabIndex: 0, // 菜单切换
      slidesDes: [
        '百闻不如一见，真实的区块链，为学习提供了实战环境，基于真实环境进行各种形式的实战任务，使区块链学习上升到全新高度。',
        '实战环境包含比特币网络、以太坊网络、智谷CTIS学习链、超级账本等8种真实环境，并不断拓展新的环境。',
        '实战平台一站式提供区块链学习和使用过程中所需的专业工具，一次性解决区块链配套工具缺失、工具资源杂乱问题。',
        '实战平台适用于工科、商科等多种专业，搭载多种难度等级的实战任务，满足所有实战学习需求。',
        '平台内置多行业、种类丰富的案例代码，并配有详尽注释，使实战练习得心应手。'
      ]
    }
  },
  created() {
    this.typing()
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    this.handleScroll()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      window.addEventListener('scroll', () => {
        this.scrollHeight = window.scrollY
      })
    },
    typing() {
      // 循环生成字节
      if (this.typingObj.i <= this.typingObj.str.length) {
        this.codeText = this.typingObj.str.slice(0, this.typingObj.i++)
        this.typingObj.timer = setTimeout(this.typing, 15)
      } else {
        this.codeText = this.typingObj.str
        clearTimeout(this.typingObj.timer)
      }
    }
  },
  watch: {
    tabIndex(val) {
      if (val === 4) {
        this.typingObj.i = 0
        this.typingObj.timer = null
        this.codeText = ''
        this.typing()
      }
    }
    // scrollTop(newVal, oldVal) {
    //   if (newVal > oldVal) {
    //     if (newVal < 800) {
    //       window.scrollTo({
    //         top: 600,
    //         behavior: 'smooth'
    //       })
    //     } else if (newVal > 600 && newVal < 1200 && newVal == window.scrollY) {
    //       window.scrollTo({
    //         top: 1500,
    //         behavior: 'smooth'
    //       })
    //     }
    //   }
    // },
  }
}
</script>

<style lang="scss">
.home {
  // font-family: PingFangSC-Medium, PingFang SC;
  padding-top: 60px;
  overflow-x: hidden;
  background-color: #fff;

  section {
    width: 100%;
    // height: calc(100vh - 60px);
    height: 700px;
    min-height: 540px;
    position: relative;
  }
  .part1 {
    height: 800px !important;
    background-color: #143662;
    display: flex;
    align-items: center;
    justify-content: center;
    .info {
      text-align: center;
      position: relative;
      bottom: 30px;
      p {
        color: #fff;
        font-size: 16px;
        position: relative;
        bottom: 100px;
      }
    }
  }
  &-btn {
    display: block;
    width: 196px;
    height: 47px;
    // background: linear-gradient(225deg, #92d5c9 0%, #59ab99 100%);
    background: #468fef;
    border-radius: 2px;
    position: absolute;
    left: 50%;
    margin-left: -88px;
    bottom: 100px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 47px;
    text-align: center;
    cursor: pointer;
  }
  .part2 {
    // max-width: 1440px;
    // margin: auto;
    box-sizing: border-box;
    padding: 0 20px;
    background: rgba(20, 54, 98, 0.17);
    display: flex;
    justify-content: center;
    align-items: center;
    .part2-right {
      width: 486px;
      height: 437px;
      position: relative;
      img {
        width: 100%;
        &:nth-child(2) {
          position: absolute;
          top: 58px;
          left: 190px;
          width: 101px !important;
          height: 32px !important;
        }
        &:nth-child(3) {
          position: absolute;
          top: 186px;
          left: 190px;
          width: 101px !important;
          height: 32px !important;
        }
        &:nth-child(4) {
          position: absolute;
          top: 330px;
          left: 190px;
          width: 101px !important;
          height: 32px !important;
        }
      }
      .taps1 {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    dl {
      width: 809px;
      margin-right: 142px;
      dt {
        font-size: 32px;
        font-weight: 500;
        color: #233244;
        line-height: 45px;
        margin-bottom: 19px;
      }
      dd {
        text-align: justify;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        line-height: 30px;
      }
    }
  }
  .slides {
    background-color: #f8f8f8;
    display: flex;
    width: 100%;
    // justify-content: space-between;
    // max-width: 1440px;
    // margin: auto;
    display: flex;
    align-items: center;
    .menu {
      // height: 100%;
      width: 259px;
      position: relative;
      z-index: 4;
      li {
        height: 80px;
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, #dadee3 0%, #d6dce4 100%);
        box-sizing: border-box;
        padding-left: 44px;
        cursor: pointer;
        color: #414e5e;
        transition: all 0.3s;
        &.active {
          width: calc(100% + 30px);
          height: 112px;
          background: linear-gradient(135deg, #78899e 0%, #0d58b6 100%);
          box-shadow: 0px 8px 60px 0px rgba(145, 158, 196, 0.3);
          color: #fff;
          transition: all 0.3s;
          border-radius: 0px 10px 10px 0px;
          dt {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: 600;
          }
          dd {
            font-size: 14px;
          }
        }
      }
      dt {
        font-size: 14px;
        margin-bottom: 6px;
        font-weight: 600;
      }
      dd {
        font-size: 12px;
      }
    }
    &-content {
      height: 100%;
      // width: 100%;
      display: flex;
      flex-wrap: nowrap;
      position: relative;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      flex: 1;
    }
    &-top {
      height: 100%;
      position: relative;

      & > div {
        // width: 100%;
        height: 100%;
      }
      .slides-part1 {
        position: relative;
        width: 664px;
        img {
          position: absolute;
          z-index: 2;
          &:nth-child(1) {
            width: 521px;
            height: 444px;
            top: 126px;
            right: 103px;
            z-index: 1 !important;
          }
          &:nth-child(2) {
            width: 417px;
            height: 350px;
            right: 49px;
            top: 243px;
            z-index: 3 !important;
          }
          &:nth-child(3) {
            width: 81px;
            height: 111px;
            left: 278px;
            top: 373px;
            z-index: 2 !important;
          }
          &:nth-child(4) {
            width: 44px;
            height: 65px;
            top: 447px;
            left: 225px;
          }
          &:nth-child(5) {
            width: 30px;
            height: 100px;
            top: 219px;
            left: 430px;
          }
          &:nth-child(6) {
            width: 49px;
            height: 49px;
            top: 179px;
            left: 398px;
          }
          &:nth-child(7) {
            width: 68px;
            height: 68px;
            top: 116px;
            left: 318px;
            opacity: 0.8;
          }
          &:nth-child(8) {
            width: 28px;
            height: 27px;
            top: 189px;
            left: 285px;
          }
          &:nth-child(9) {
            width: 87px;
            height: 87px;
            top: 235px;
            left: 218px;
          }
          &:nth-child(10) {
            width: 312px;
            height: 168px;
            top: 247px;
            left: 54px;
          }
          &:nth-child(11) {
            width: 86px;
            height: 86px;
            top: 191px;
            left: 88px;
          }
          &:nth-child(12) {
            width: 112px;
            height: 68px;
            top: 179px;
            right: 28px;
          }
          &:nth-child(13) {
            width: 109px;
            height: 64px;
            top: 115px;
            left: 0px;
          }
        }
      }
      .slides-part2 {
        width: 860px !important;
        position: relative;
        background-color: #f8f8f8;
        img {
          &:first-child {
            width: 823px;
            position: absolute;
            top: 98px;
            left: 68px;
            z-index: 1;
          }
          &:nth-child(2) {
            z-index: 2;
            width: 135px;
            position: absolute;
            bottom: 136px;
          }
          &:nth-child(3) {
            z-index: 2;
            width: 80px;
            position: absolute;
            bottom: 215px;
            left: 182px;
          }
          &:nth-child(4) {
            z-index: 2;
            width: 119px;
            position: absolute;
            top: 119px;
            left: 413px;
          }
          &:nth-child(5) {
            z-index: 2;
            width: 249px;
            position: absolute;
            top: 202px;
            left: 282px;
          }
          &:nth-child(6) {
            z-index: 3;
            height: 436px;
            position: absolute;
            top: 162px;
            left: 471px;
          }
          &:nth-child(7) {
            z-index: 2;
            height: 177px;
            position: absolute;
            top: 305px;
            right: 51px;
          }
        }
      }
      .slides-part3 {
        background-color: #f8f8f8;
        position: relative;
        width: 807px !important;
        height: 459px;
        margin-top: 111px;
        img {
          transform: scale(1) translateX(1400px);
          @keyframes outInRight {
            from {
              opacity: 1;
              transform: scale(1) translateX(1400px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateX(0px);
            }
          }
          z-index: 1;
          position: absolute;
          &:nth-child(1) {
            width: 784px;
            z-index: 0;
          }
          &:nth-child(2) {
            animation: outInRight 0.6s linear 0.8s forwards, scaleDrew 1.5s ease-out 2s infinite alternate;
            width: 82px;
            left: 71px;
            bottom: 160px;
          }
          &:nth-child(3) {
            animation: outInRight 0.65s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 182px;
            bottom: 65px;
            left: 17px;
          }
          &:nth-child(4) {
            animation: outInRight 0.7s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 71px;
            left: 171px;
            top: 112px;
          }
          &:nth-child(5) {
            animation: outInRight 0.75s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.6s infinite alternate;
            width: 150px;
            bottom: 0;
            left: 143px;
          }
          &:nth-child(6) {
            animation: outInRight 0.8s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 58px;
            left: 287px;
            top: 30px;
          }
          &:nth-child(7) {
            animation: outInRight 0.85s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.7s infinite alternate;
            width: 99px;
            bottom: 57px;
            left: 344px;
          }
          &:nth-child(8) {
            animation: outInRight 0.9s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.9s infinite alternate;
            width: 142px;
            top: 30px;
            right: 175px;
          }
          &:nth-child(9) {
            animation: outInRight 0.95s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.6s infinite alternate;
            width: 206px;
            top: 96px;
            right: 146px;
          }
          &:nth-child(10) {
            animation: outInRight 1s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.5s infinite alternate;
            width: 153px;
            top: 183px;
            right: 132px;
          }
          &:nth-child(11) {
            animation: outInRight 1.05s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 112px;
            top: 163px;
            right: 0px;
          }
        }
      }
      .slides-part4 {
        width: 689px !important;
        height: 100%;
        position: relative;

        img {
          position: absolute;
          width: 111px;
          height: 110px;
          &:nth-child(1) {
            top: 214px;
            left: 0;
          }
          &:nth-child(2) {
            top: 148px;
            left: 205px;
          }
          &:nth-child(3) {
            top: 316px;
            left: 168px;
          }
          &:nth-child(4) {
            top: 233px;
            right: 211px;
          }
          &:nth-child(5) {
            top: 347px;
            right: 78px;
          }
          &:nth-child(6) {
            top: 205px;
            right: 0;
          }
        }
      }
      .slides-part5 {
        position: relative;
        width: 630px !important;
        display: flex;
        align-items: center;
        img {
          width: 630px;
          height: 490px;
        }
        p {
          position: absolute;
          line-height: 20px;
          top: 366px;
          font-size: 12px;
          left: 500px;
          opacity: 0.5;
        }
      }
    }

    &-des {
      height: 100%;
      line-height: 120px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: justify;
      color: #666;
      line-height: 30px;
      box-sizing: border-box;
      padding: 0 2px;
      &:nth-child(2) {
        width: 200px;
      }
      &:nth-child(1) {
        width: 210px;
      }
      &:nth-child(3) {
        width: 210px;
        margin-left: 4%;
      }
      &:nth-child(5) {
        width: 210px;
      }
    }
    &-part1,
    &-part4 {
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-part2,
    &-part3 {
      background-color: #fff;
    }
    &-part5 {
      max-width: 1440px;
      margin: auto;
      position: relative;
      p {
        width: 500px;
        height: 390px;
        line-height: 30px;
        position: absolute;
        left: 50%;
        margin-left: -250px;
        top: 50%;
        margin-top: -195px;
        color: #fff;
        font-family: PingFangSC-Light, PingFang SC;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .part8 {
    max-width: 1440px;
    margin: auto;
    background-color: #fff;
    position: relative;
    h2 {
      font-size: 24px;
      font-weight: bold;
      padding: 83px 0 98px 0;
      text-align: center;
    }
    .partner {
      display: flex;
      width: 100%;
      flex-flow: row nowrap;
      .partner-left {
        width: 1152px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        p {
          flex: 0 0 25%;
        }
      }
      .partner-right {
        width: 288px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        p {
          &:first-child {
            height: 77px !important;
            img {
              height: 56px !important;
              // width: 120px;
            }
          }
          &:last-child {
            height: 153px;
            img {
              height: 112px !important;
            }
          }
        }
      }
      p {
        box-sizing: border-box;
        height: 77px;
        display: flex;
        align-items: center;
        justify-content: center;
        // &:nth-of-type(12) {
        //   display: block;
        //   text-align: center;
        // }
        img {
          width: 120px;
        }
      }
    }
    .btn {
      width: 180px;
      height: 48px;
      background: #468fef;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      position: absolute;
      left: 50%;
      bottom: 105px;
      margin-left: -90px;
      display: block;
      text-align: center;
      line-height: 48px;
    }
  }
  .part-footer {
    width: 100%;
    background: #143662;
  }
  .footer {
    max-width: 1440px;
    margin: auto;
    padding: 0 40px;
    height: 168px;
    background: #143662;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    a {
      color: #fff;
    }
    line-height: 30px;
  }
}
@media screen and (max-width: 1440px) {
  .home {
    .part2 {
      display: flex;
      justify-content: center;
      dl {
        width: 619px;
        margin-right: 7%;
      }
      .part2-right {
        width: 396px;
        img {
          &:nth-child(1) {
            width: 396px;
            height: 355px;
          }
          &:nth-child(2) {
            width: 82px !important;
            height: 25px !important;
            top: 48px;
            left: 155px;
          }
          &:nth-child(3) {
            width: 82px !important;
            height: 25px !important;
            top: 152px;
            left: 155px;
          }
          &:nth-child(4) {
            width: 82px !important;
            height: 25px !important;
            top: 269px;
            left: 155px;
          }
        }
      }
    }
    .slides {
      .slides-content {
        .slides-des {
          font-size: 12px;
          line-height: 24px;
          &:nth-child(1) {
            width: 251px !important;
          }
          &:nth-child(2) {
            width: 251px !important;
          }
          &:nth-child(3) {
            width: 180px !important;
          }
          &:nth-child(4) {
            width: 180px !important;
          }
        }
      }
      .slides-part1 {
        position: relative;
        width: 501px;
        img {
          position: absolute;
          z-index: 2;
          &:nth-child(1) {
            width: 393px;
            height: 335px;
            top: 174px;
            right: 78px;
            z-index: 1 !important;
          }
          &:nth-child(2) {
            width: 315px;
            height: 264px;
            right: 37px;
            top: 263px;
            z-index: 3 !important;
          }
          &:nth-child(3) {
            width: 60px;
            height: 88px;
            left: 206px;
            top: 358px;
            z-index: 2 !important;
          }
          &:nth-child(4) {
            width: 33px;
            height: 48px;
            top: 417px;
            left: 170px;
          }
          &:nth-child(5) {
            width: 21px;
            height: 71px;
            top: 248px;
            left: 329px;
          }
          &:nth-child(6) {
            width: 38px;
            height: 38px;
            top: 210px;
            left: 296px;
          }
          &:nth-child(7) {
            width: 51px;
            height: 47px;
            top: 170px;
            left: 240px;
            opacity: 0.8;
          }
          &:nth-child(8) {
            width: 21px;
            height: 20px;
            top: 223px;
            left: 215px;
          }
          &:nth-child(9) {
            width: 60px;
            height: 60px;
            top: 250px;
            left: 174px;
          }
          &:nth-child(10) {
            width: 236px;
            height: 126px;
            top: 265px;
            left: 41px;
          }
          &:nth-child(11) {
            width: 46px;
            height: 50px;
            top: 220px;
            left: 80px;
          }
          &:nth-child(12) {
            width: 85px;
            height: 51px;
            top: 214px;
            right: 21px;
          }
          &:nth-child(13) {
            width: 82px;
            height: 48px;
            top: 166px;
            left: 0px;
          }
        }
      }
      .slides-part2 {
        width: 654px !important;
        position: relative;
        background-color: #f8f8f8;
        img {
          &:first-child {
            width: 582px;
            position: absolute;
            top: 173px;
            right: 24px;
            z-index: 1;
          }
          &:nth-child(2) {
            z-index: 2;
            width: 95px;
            position: absolute;
            bottom: 201px;
          }
          &:nth-child(3) {
            z-index: 2;
            width: 64px;
            position: absolute;
            bottom: 255px;
            left: 129px;
          }
          &:nth-child(4) {
            z-index: 2;
            width: 66px;
            position: absolute;
            top: 188px;
            left: 292px;
          }
          &:nth-child(5) {
            z-index: 2;
            width: 176px;
            position: absolute;
            top: 250px;
            left: 200px;
          }
          &:nth-child(6) {
            z-index: 3;
            height: 320px;
            width: 230px;
            position: absolute;
            top: 212px;
            left: 333px;
          }
          &:nth-child(7) {
            z-index: 2;
            height: 126px;
            position: absolute;
            top: 330px;
            right: 51px;
          }
        }
      }
      .slides-part3 {
        background-color: #f8f8f8;
        position: relative;
        width: 716px !important;
        // margin-top: 111px;
        img {
          transform: scale(1) translateX(1400px);
          @keyframes outInRight {
            from {
              opacity: 1;
              transform: scale(1) translateX(1400px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateX(0px);
            }
          }
          z-index: 1;
          position: absolute;
          &:nth-child(1) {
            width: 620px;
            z-index: 0;
            top: 67px;
            left: 41px;
          }
          &:nth-child(2) {
            animation: outInRight 0.6s linear 0.8s forwards, scaleDrew 1.5s ease-out 2s infinite alternate;
            width: 82px;
            left: 0px;
            bottom: 200px;
          }
          &:nth-child(3) {
            animation: outInRight 0.65s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 181px;
            bottom: 110px;
            left: 0px;
          }
          &:nth-child(4) {
            animation: outInRight 0.7s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 71px;
            left: 161px;
            top: 152px;
          }
          &:nth-child(5) {
            animation: outInRight 0.75s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.6s infinite alternate;
            width: 150px;
            bottom: 30px;
            left: 100px;
          }
          &:nth-child(6) {
            animation: outInRight 0.8s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 58px;
            left: 287px;
            top: 30px;
          }
          &:nth-child(7) {
            animation: outInRight 0.85s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.7s infinite alternate;
            width: 99px;
            bottom: 80px;
            left: 290px;
          }
          &:nth-child(8) {
            animation: outInRight 0.9s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.9s infinite alternate;
            width: 142px;
            top: 30px;
            right: 135px;
          }
          &:nth-child(9) {
            animation: outInRight 0.95s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.6s infinite alternate;
            width: 206px;
            top: 100px;
            right: 30px;
          }
          &:nth-child(10) {
            animation: outInRight 1s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.5s infinite alternate;
            width: 136px;
            top: 200px;
            right: 132px;
          }
          &:nth-child(11) {
            animation: outInRight 1.05s linear 0.8s forwards, scaleDrew 1.5s ease-out 1.8s infinite alternate;
            width: 112px;
            top: 163px;
            right: 0px;
          }
        }
      }
      .slides-part4 {
        width: 560px !important;
        height: 100%;
        position: relative;
        align-items: center;
        img {
          position: absolute;
          width: 80px;
          height: 79px;
          &:nth-child(1) {
            top: 279px;
            left: 0;
          }
          &:nth-child(2) {
            top: 231px;
            left: 180px;
          }
          &:nth-child(3) {
            top: 352px;
            left: 138px;
          }
          &:nth-child(4) {
            top: 294px;
            right: 190px;
          }
          &:nth-child(5) {
            top: 375px;
            right: 90px;
          }
          &:nth-child(6) {
            top: 271px;
            right: 0;
          }
        }
      }
      .slides-part5 {
        position: relative;
        width: 500px !important;
        display: flex;
        align-items: center;
        img {
          width: 500px;
          height: 354px;
        }
        p {
          position: absolute;
          line-height: 14px;
          top: 420px;
          font-size: 12px;
          left: 426px;
          opacity: 0.5;
        }
      }
    }
    .slides .menu dt {
      font-size: 14px;
      font-weight: 600;
    }
    .slides .menu li {
      padding-left: 30px;
      &.active {
        width: calc(100% + 30px);
      }
    }
    .part8 {
      .partner {
        box-sizing: border-box;
        padding: 0 160px;
        img {
          width: 50% !important;
        }
      }
      .btn {
        margin-left: -96px;
        width: 196px !important;
        height: 44px !important;
        line-height: 44px;
      }
    }
  }
}
</style>
